import { type RefObject, useEffect, useRef } from "react";

type Entry = { run(): void; element?: RefObject<HTMLElement | null> };
const entries: Entry[] = [];
function current() {
  const dialog = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).at(-1);
  return [...entries].reverse().find((entry) => (dialog ? entry.element?.current === dialog : !entry.element));
}
function sync() {
  const button = window.Telegram?.WebApp?.BackButton;
  if (current()) button?.show();
  else button?.hide();
}
export function goBack() {
  current()?.run();
}
function keyboard(event: KeyboardEvent) {
  const dialog = Array.from(document.querySelectorAll<HTMLElement>('[role="dialog"][aria-modal="true"]')).at(-1);
  if (event.key === "Tab" && dialog) {
    const nodes = [
      ...dialog.querySelectorAll<HTMLElement>(
        'button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href],[tabindex="0"]',
      ),
    ].filter((node) => node.getClientRects().length);
    const first = nodes[0],
      last = nodes.at(-1);
    if (!first || (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement)))) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
    return;
  }
  if (event.key !== "Escape" || document.querySelector('[role="dialog"][aria-modal="true"]')) return;
  if (current()) {
    event.preventDefault();
    goBack();
  }
}
export function useBackNavigation(onBack: () => void, enabled = true, element?: RefObject<HTMLElement | null>) {
  const callback = useRef(onBack);
  callback.current = onBack;
  useEffect(() => {
    if (!enabled) {
      sync();
      return;
    }
    const entry: Entry = { run: () => callback.current(), element };
    if (entries.length === 0) {
      window.Telegram?.WebApp?.BackButton?.onClick(goBack);
      document.addEventListener("keydown", keyboard);
    }
    entries.push(entry);
    sync();
    return () => {
      entries.splice(entries.indexOf(entry), 1);
      if (entries.length === 0) {
        window.Telegram?.WebApp?.BackButton?.offClick(goBack);
        document.removeEventListener("keydown", keyboard);
      }
      sync();
    };
  }, [enabled, element]);
}
